import { render, staticRenderFns } from "./Form1583Notification.vue?vue&type=template&id=638c4002"
import script from "./Form1583Notification.vue?vue&type=script&lang=js"
export * from "./Form1583Notification.vue?vue&type=script&lang=js"
import style0 from "./Form1583Notification.vue?vue&type=style&index=0&id=638c4002&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports